import React from 'react';
import { ArrowRight, Globe } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  const whatsappUrl = 'https://wa.me/2250700592164';
  return <section className="relative overflow-hidden bg-background py-20 md:py-32" data-id="element-45">
      <div className="container mx-auto px-4 md:px-6" data-id="element-46">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center" data-id="element-47">
          <div className="flex flex-col justify-center space-y-8" data-id="element-48">
            <div className="space-y-4" data-id="element-49">
              <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl xl:text-6xl/none text-foreground" data-id="element-50">
                Payez vos fournisseurs à l'international en toute simplicité
              </h1>
              <p className="max-w-[600px] text-muted-foreground md:text-xl" data-id="element-51">
                CafaPay permet aux importateurs en Côte d'Ivoire de régler leurs
                fournisseurs en Chine, en Turquie et à Dubaï avec une carte Visa
                USD. Rapide, sécurisé et sans complications.
              </p>
            </div>
            <div className="flex flex-col gap-3 min-[400px]:flex-row" data-id="element-52">
              <Button size="lg" className="gap-2" onClick={() => window.open(whatsappUrl, '_blank')} data-id="element-53">
                Commencer maintenant <ArrowRight className="h-4 w-4" data-id="element-54" />
              </Button>
              <Button variant="outline" size="lg" onClick={() => window.open(whatsappUrl, '_blank')} data-id="element-55">
                En savoir plus
              </Button>
            </div>
            <div className="flex items-center space-x-4 text-sm text-muted-foreground" data-id="element-56">
              <div className="flex items-center gap-1" data-id="element-57">
                <div className="h-2 w-2 rounded-full bg-green-500" data-id="element-58" />
                <span data-id="element-59">Disponible 24/7</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-60">
                <div className="h-2 w-2 rounded-full bg-blue-500" data-id="element-61" />
                <span data-id="element-62">Support Français</span>
              </div>
            </div>
          </div>

          {/* Hero Illustration */}
          <div className="mx-auto w-full max-w-[500px] lg:max-w-none" data-id="element-63">
            <div className="relative aspect-square overflow-hidden rounded-xl bg-muted/50 p-8 flex items-center justify-center border border-border shadow-xl" data-id="element-64">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-secondary/20" data-id="element-65" />

              {/* Abstract representation of payment flow */}
              <div className="relative z-10 w-full max-w-sm space-y-6" data-id="element-66">
                {/* Card 1: Ivory Coast Importer */}
                <div className="rounded-lg bg-card p-4 shadow-lg border border-border flex items-center gap-4 animate-in slide-in-from-left-4 duration-700" data-id="element-67">
                  <div className="h-10 w-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-bold" data-id="element-68">
                    CI
                  </div>
                  <div data-id="element-69">
                    <div className="h-2.5 w-24 bg-muted rounded mb-2" data-id="element-70" />
                    <div className="h-2 w-16 bg-muted/50 rounded" data-id="element-71" />
                  </div>
                  <div className="ml-auto font-mono text-sm font-medium text-foreground" data-id="element-72">
                    - $5,000
                  </div>
                </div>

                {/* Connection Line */}
                <div className="flex justify-center py-2" data-id="element-73">
                  <div className="h-12 w-0.5 bg-border relative" data-id="element-74">
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary text-primary-foreground rounded-full p-1.5" data-id="element-75">
                      <Globe className="h-4 w-4" data-id="element-76" />
                    </div>
                  </div>
                </div>

                {/* Card 2: China Supplier */}
                <div className="rounded-lg bg-card p-4 shadow-lg border border-border flex items-center gap-4 animate-in slide-in-from-right-4 duration-700 delay-200" data-id="element-77">
                  <div className="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center text-red-600 font-bold text-xs" data-id="element-78">
                    CN
                  </div>
                  <div data-id="element-79">
                    <div className="h-2.5 w-16 bg-muted rounded mb-2" data-id="element-80" />
                    <div className="h-2 w-10 bg-muted/50 rounded" data-id="element-81" />
                  </div>
                  <div className="ml-auto font-mono text-xs font-medium text-green-600" data-id="element-82">
                    + $5,000
                  </div>
                </div>

                {/* Card 3: Turkey Supplier */}
                <div className="rounded-lg bg-card p-4 shadow-lg border border-border flex items-center gap-4 animate-in slide-in-from-right-4 duration-700 delay-300" data-id="element-83">
                  <div className="h-10 w-10 rounded-full bg-red-50 flex items-center justify-center text-red-500 font-bold text-xs" data-id="element-84">
                    TR
                  </div>
                  <div data-id="element-85">
                    <div className="h-2.5 w-16 bg-muted rounded mb-2" data-id="element-86" />
                    <div className="h-2 w-10 bg-muted/50 rounded" data-id="element-87" />
                  </div>
                  <div className="ml-auto font-mono text-xs font-medium text-green-600" data-id="element-88">
                    + $3,200
                  </div>
                </div>

                {/* Card 4: Dubai Supplier */}
                <div className="rounded-lg bg-card p-4 shadow-lg border border-border flex items-center gap-4 animate-in slide-in-from-right-4 duration-700 delay-500" data-id="element-89">
                  <div className="h-10 w-10 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-600 font-bold text-xs" data-id="element-90">
                    AE
                  </div>
                  <div data-id="element-91">
                    <div className="h-2.5 w-16 bg-muted rounded mb-2" data-id="element-92" />
                    <div className="h-2 w-10 bg-muted/50 rounded" data-id="element-93" />
                  </div>
                  <div className="ml-auto font-mono text-xs font-medium text-green-600" data-id="element-94">
                    + $4,800
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}